import { IndexTable } from 'components/ControlledTable';
import { ReactElement } from 'react';
import { CampaignsView, StageIndicators, viewFilterMap } from './types';
import { stages } from './stages';
import invariant from 'tiny-invariant';
import { CompanyFilterChip } from 'modules/core/company/components';
import { SearchFilterInput } from 'components/filters/SearchFilterInput';

type StageContainerProps = {
  view: CampaignsView;
  stage: keyof StageIndicators;
};

const tableProps = { size: 'xs' } as const;
export function StageContainer({ view, stage }: StageContainerProps): ReactElement {
  const config = stages[stage];
  invariant('url' in config);
  const { queryParms, columns, url } = config;

  return (
    <IndexTable<any>
      // no sticky filters
      storageKey={null}
      filterFields={
        <>
          <SearchFilterInput />
          <CompanyFilterChip name="related_client" label="Client or payer" />
        </>
      }
      url={url}
      columns={columns}
      pageSize={15}
      queryParams={{ view: viewFilterMap[view], ...queryParms }}
      tableProps={tableProps}
    />
  );
}
